module.exports = __webpack_public_path__ + "static/media/cy.5e40be33.svg";